import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { CrmHero } from './CrmHero';
import { CrmAudience } from './CrmAudience';
import { CrmProduct } from './CrmProduct';
import { CrmRelationship } from './CrmRelationship';
import { CrmComparison } from './CrmComparison';
import { CrmPricing } from './CrmPricing';
import { CrmCta } from './CrmCta';

/**
 * Lift2Fit for coaches & gyms — the CRM marketing page.
 *
 * A separate page with its own header navigation, sections and footer, mounted
 * at `/for-coaches` by `App.tsx`. The CRM audience never shares a page with the
 * lifter proposition (platform plan §3), so this component composes only the
 * CRM sections — no lifter hero, no lifter pricing.
 */
export function CrmLanding() {
  return (
    <div className="min-h-screen bg-page">
      <a
        href="#crm-main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:border focus:border-accent focus:bg-surface focus:px-4 focus:py-2 focus:text-[13px] focus:font-bold focus:uppercase focus:tracking-[0.08em] focus:text-ink"
      >
        Skip to content
      </a>

      <Header audience="crm" />

      <main id="crm-main">
        <CrmHero />
        <CrmAudience />
        <CrmProduct />
        <CrmRelationship />
        <CrmComparison />
        <CrmPricing />
        <CrmCta />
      </main>

      <Footer audience="crm" />
    </div>
  );
}
